export const creditorConstants = {
  STRATA_MASTER_CREDITOR_BASE_PATH: '/v1/strata_master_creditors',
  BASE_PATH: '/v1/contractors',
  BPAY_PAYMENT_METHOD: 'bpay',
};
